import config from 'config';
import {utility} from "../utilites/index";
import ActiveRecordResource from "./ActiveRecordResource";

export interface CategoryDTO{
  id: string;
  name: string;
}

export class VideoCategory extends ActiveRecordResource {
  category_id: string;
  name: string;

  static path = `${config.backOfficeBasePath}/streams/categories`;

  static validateConstraints = {};

  static mapRecords(data) {
    return data.map((item) => this.parseData(item));
  }

  _getModel() {
    return VideoCategory;
  }

  static listAction(query) {
    let path = this.path;

    query = Object.assign({}, query);
    return utility.networkLayer.getJson(path, query)
      .then(data => this.mapRecords(data));
  }

  private static parseData(data: CategoryDTO) {
    let res = new VideoCategory({});

    return Object.assign(res, res._parseData(data));
  }

  _parseData(data: CategoryDTO) {
    let res: any = {
      category_id: data.id,
      name: data.name
    };

    return res;
  }

  get id(){
    return this.category_id;
  }
}

export default VideoCategory;



// WEBPACK FOOTER //
// ./src/api/video_category.ts